import { Checkbox, getFontCss, styleConstants, themeConstants } from '@paywithextend/components'
import React from 'react'
import Trns from 'src/localization/Trns'
import { TransactionStatus } from 'src/models/transaction.models'
import { css } from 'styled-components'

interface TransactionStatusFilterProps {
  statusSet: Set<string>
  handleStatusSelection: (status: string) => Set<string>
}

const TransactionStatusFilter: React.FC<TransactionStatusFilterProps> = ({
  statusSet,
  handleStatusSelection,
}) => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 12px;
      `}
    >
      <div
        css={css`
          ${getFontCss(
            14,
            themeConstants.colors.font_primary,
            styleConstants.fontFamilies.medium,
          )};
        `}
      >
        <Trns source={'Transaction Status'} />
      </div>
      <Checkbox
        label={<Trns source={'Cleared'} />}
        onClick={(): void => {
          handleStatusSelection(TransactionStatus.Cleared)
        }}
        isSelected={statusSet.has(TransactionStatus.Cleared)}
      />
      <Checkbox
        label={<Trns source={'Declined'} />}
        onClick={(): void => {
          handleStatusSelection(TransactionStatus.Declined)
        }}
        isSelected={statusSet.has(TransactionStatus.Declined)}
      />
      <Checkbox
        label={<Trns source={'Pending'} />}
        onClick={(): void => {
          handleStatusSelection(TransactionStatus.Pending)
        }}
        isSelected={statusSet.has(TransactionStatus.Pending)}
      />
      <Checkbox
        label={<Trns source={'Reversal'} />}
        onClick={(): void => {
          handleStatusSelection(TransactionStatus.AuthReversal)
        }}
        isSelected={statusSet.has(TransactionStatus.AuthReversal)}
      />
    </div>
  )
}

export default TransactionStatusFilter
